import React from 'react';

import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  language: string
};

class PageNotFoundMessage extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const {
      language // eslint-disable-line no-unused-vars
    } = this.props;

    return (
      <div className='esko_pagenotfound404error'>
        <h1>{translate('shared.nav.error404.pagenotfound')}</h1>
        <p>{translate('shared.nav.error404.recheckurl')}</p>
      </div>
    );
  }
}

export default PageNotFoundMessage;
